import styled from "styled-components"
import Airdome1 from "../assets/images/airdome-1.png"
import Housing1 from "../assets/images/low-cost-housing-1.jpg"
import { phoneWidth } from "../Globalstyle"

const StyledBlock = styled.div`
`

const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: var(--side-padding);
`
const HeaderTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
`

const StyledDetails = styled.div`
  background-color: var(--tan);
`

const DetailsRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;

  @media (max-width: ${phoneWidth}) {
    display: flex;
    flex-direction: column;
  }
`

const PhaseDetails = styled.div`
  padding: var(--side-padding);
`

const PhaseNumber = styled.div`
  font-size: 1.25rem;
  color: var(--gray);
  font-weight: bold;
`

const PhaseTitle = styled.div`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  margin-top: 2rem;
`

const PhaseText = styled.div``

const ImageContainer = styled.div`
  width: 100%;
  height: 35rem;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ImageDome = styled.img`
  width: 100%;
  object-fit: cover;
`

const ImageHousing = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 0 0;
`

const ReliefProgram = () => {
  return (
    <StyledBlock>
      <StyledHeader>
        <HeaderTitle>
          Relief Program
        </HeaderTitle>
        <div>
          The relief program will be carried out in two phases.
        </div>
      </StyledHeader>
      <StyledDetails>
        <DetailsRow>
          <ImageContainer>
            <ImageDome src={Airdome1} alt="Flood victims"/>
          </ImageContainer>
          <PhaseDetails>
            <PhaseNumber>
              Phase 1
            </PhaseNumber>
            <PhaseTitle>
              Base Camp and Air Dome Construction
            </PhaseTitle>
            <PhaseText>
              Our goal is to provide temporary shelter to the displaced 
              in an Air Dome, which is 35,000 sq.ft. in size and can easily 
              accommodate at least 50 to 70 families who have lost their homes.
              Containers will be used to set up several stations such as kitchens, 
              toilets, a lab for PCR tests, medical storage, supply storage, 
              and a control room.
            </PhaseText>
            <PhaseTitle>
              Care Package
            </PhaseTitle>
            <PhaseText>
              Care packages will be distributed among families who have been directly 
              affected by the flood. Each package will several food items and non-food items.
            </PhaseText>
          </PhaseDetails>
        </DetailsRow>
        <DetailsRow>
          <PhaseDetails>
            <PhaseNumber>Phase 2</PhaseNumber>
            <PhaseTitle>Community Building</PhaseTitle>
            <PhaseText>
              We will build low cost housing and e-stores for several families who have 
              lost their homes. Families will be provided monthly rations for free.
            </PhaseText>
          </PhaseDetails>
          <ImageContainer>
            <ImageHousing src={Housing1} alt="Flood victims"/>
          </ImageContainer>
        </DetailsRow>
      </StyledDetails>
    </StyledBlock>
  )
}

export default ReliefProgram